import { ChangeDetectionStrategy, Component, ViewChildren, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { GroupCellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'grid-faultmsg',
  templateUrl: './grid-faultmsg.component.html',
  styleUrls: ['./grid-faultmsg.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'lau-GridCellFaultMsg',
  },
})
export class GridFaultMsgComponent {
  params: GroupCellRendererParams;
  faultMsg = new UntypedFormControl();

  @ViewChildren('faultMsgInput') faultMsgInput;

  agInit(params) {
    this.params = params;
    this.faultMsg.setValue(params.value);
  }

  afterGuiAttached(params) {
    window.setTimeout(() => {
      this.faultMsgInput.first.nativeElement.focus();
    });
  }

  getValue(): any {
    return this.faultMsg.value;
  }

  onFocusOut(e) {
    if (e.sourceCapabilities) {
      this.params.api.stopEditing();
    }
  }
}
